<template>
    <div id="analisis-wrapper">
        <div class="row" id="analisis-list">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Análises registradas</div>
                    </div>
                    <div class="card-body messages" id="messagesList">
                        <div v-if="!analisisList.length">
                            <h5 class='centered'>
                                Ainda não há análises registradas para esta Pesquisa
                            </h5>
                            <h6 class='centered'>
                                Você pode criar uma abaixo
                            </h6>
                        </div>

                        <div v-if="analisisList.length">
                            <div class="row" v-for="analisisItem in analisisList" :key="analisisItem.id">
                                <div class="col-md-12">
                                    <div class="row mb-3" v-if="analisisItem.responsible_id != $store.getters.user.id">
                                        <div class="col-1">
                                            <img class='chat-user-image float-right' :src="analisisItem.user.photo_http " alt="">
                                        </div>
                                        <div class="col-6 chat-message">
                                            <p class="text-left">
                                            <strong>{{normalizeName(analisisItem.user.name)}}</strong><br>
                                            {{ analisisItem.description }}
                                            </p>
                                            <div class="centered mt-4 mb-2" v-if="analisisItem.file">
                                                <a :href="analisisItem.file_http" targer="_blank">
                                                    <i class='fas fa-file fa-3x'></i>
                                                    <br>
                                                    Baixar Anexo
                                                </a>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 text-right">
                                                    Enviado em: {{ formatDateTime(analisisItem.created_at) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-3" v-if="analisisItem.responsible_id == $store.getters.user.id">
                                        <div class="offset-5 col-6 chat-message">
                                            <p class="text-left">
                                            <strong>{{normalizeName(analisisItem.user.name)}}</strong><br>
                                            {{ analisisItem.description }}
                                            </p>
                                            <div class="centered mt-4 mb-2" v-if="analisisItem.file">
                                                <a :href="analisisItem.file_http" targer="_blank">
                                                    <i class='fas fa-file fa-3x'></i>
                                                    <br>
                                                    Baixar Anexo
                                                </a>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 text-right">
                                                    Enviado em: {{ formatDateTime(analisisItem.created_at) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-1">
                                            <img class='chat-user-image float-left' :src="analisisItem.user.photo_http " alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="analisis-create" v-if="research && research.status_id >= 4">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Criar Análise</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="nameInput">Descrição</label>
                                    <textarea rows="5" class='form-control' v-model="analisis.description"></textarea>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="placeInput">Anexo</label>
                                    <input type="file" class="form-control" id="analisis_file"/>
                                </div>
                                <br>
                                <button class='btn btn-normal btn-block' @click="save">
                                    <i class='fas fa-paper-plane'></i>
                                    Enviar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            analisis: {
                description: '',
            },
            analisisList: [],
            research: {}
        };
    },
    computed: {},
    methods: {
        normalizeName(string) {
            let name_to_lowercase = string.toLowerCase();
            return name_to_lowercase.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
        },
        formatDateTime(dateTime){
            return moment(dateTime).format('DD/MM/YYYY HH:mm:ss ')
        },
        makeFormData(){
            const fd = new FormData()

            fd.append('description', this.analisis.description)
            fd.append('research_id', this.$route.params.id)

            let file = document.getElementById('analisis_file').files[0]
            if(file){
                fd.append('file', file)
            }

            if(this.analisis.id){
                fd.append('_method', 'PUT')
            }

            return fd
        },
        clear(){
            this.analisis = {
                description: '',
            }
            document.getElementById('analisis_file').value = ""
        },
        save(){
            const self = this
            let api = self.$store.state.api + 'researchanalisis'

            if(self.analisis.id){
                api += '/' + self.analisis.id
            }

            const fd = self.makeFormData()

            self.$http.post(api, fd)
                .then((response) => {
                    self.clear()
                    self.getAnalisisList()
                    self.$message('Sucesso', 'Análise salva com sucesso', 'success')
                }).catch((error) => {
                    self.$message('Erro', error.response.data, 'error');
                });
        },
        getAnalisisList(){
            const self = this
            const api = self.$store.state.api + 'researchanalisis?research_id=' + self.$route.params.id + '&with[]=user&paginated=false'
            self.$http.get(api)
                .then((response) => {
                    self.analisisList = response.data.data
                    self.$nextTick(() => {
                        self.scrollBottom()
                    })
                }).catch((error) => {
                    self.$message('Erro', error.response.data, 'error');
                });
        },
        getResearch(){
            const self = this
            const api = self.$store.state.api + 'researches/' + self.$route.params.id
            self.$http.get(api)
                .then((response) => {
                    self.research = response.data.data[0]
                }).catch((error) => {
                    self.$message('Erro', error.response.data, 'error');
                });
        },
        scrollBottom(){
            var element = document.getElementById("messagesList");
            element.scrollTop = element.scrollHeight;
        }
    },
    mounted: function() {
        this.getAnalisisList()
        this.getResearch()
    }
};
</script>

<style scoped>
.card-body.messages {
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/Analisis/Analisis.vue